import React from 'react';

interface ContainerSizeControllerProps {
    size?: string; // Optional size like "2200px"
    responsivePadding?: boolean; // Enable responsive padding
}

/**
 * A utility component that injects CSS to control container width
 * throughout the application, including header and footer
 */
const ContainerSizeController: React.FC<ContainerSizeControllerProps> = ({ size, responsivePadding = true }) => {
    // CSS for responsive padding
    const responsivePaddingCSS = responsivePadding
        ? `
        /* Responsive container padding */
        @media (max-width: 767px) {
            .container {
                padding-left: 0.5rem;
                padding-right: 0.5rem;
            }
        }
        @media (min-width: 768px) and (max-width: 1023px) {
            .container {
                padding-left: 1rem;
                padding-right: 1rem;
            }
        }
        @media (min-width: 1024px) {
            .container {
                padding-left: 1rem;
                padding-right: 1rem;
            }
        }
    `
        : '';

    // CSS to control container width
    const sizeCSS = size
        ? `
        .container {
            max-width: ${size} ;
        }
        /* Fix navbar and footer stretching issue */
        header .container, footer .container {
            max-width: ${size} ;
            margin: 0 auto ;
        }
    `
        : '';

    // If neither size nor responsive padding is provided, don't render anything
    if (!size && !responsivePadding) return null;

    return (
        <style>
            {responsivePaddingCSS}
            {sizeCSS}
        </style>
    );
};

export default ContainerSizeController;
